import { css } from '@emotion/react'
import clsx from 'clsx'
import { noop } from 'lodash-es'
import { nanoid } from 'nanoid'
import type { CSSProperties } from 'react'
import * as React from 'react'
import { useState } from 'react'
import type { DefaultProps } from 'src/types'

import S from './CheckboxButton.style'

type Props = {
  id?: string
  checked?: boolean
  defaultChecked?: boolean
  name?: string
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  value?: string
  width?: CSSProperties['width']
  height?: CSSProperties['height']
  disabled?: boolean
} & DefaultProps

const CheckboxButton = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      id,
      children,
      className,
      onClick,
      width = 80,
      height = 38,
      disabled = false,
      ...props
    }: Props,
    ref,
  ) => {
    const [uniqueId] = useState(nanoid())

    return (
      <button
        css={S.CheckboxButton}
        className={clsx(className, disabled && 'disabled')}
        onClick={disabled ? noop : onClick}
        style={{ width, height }}
      >
        <input
          ref={ref}
          type="checkbox"
          css={css`
            display: none;
          `}
          id={id ?? uniqueId}
          disabled={disabled}
          {...props}
        />
        <label htmlFor={id}>{children}</label>
      </button>
    )
  },
)

CheckboxButton.displayName = 'CheckboxButton'

export default CheckboxButton
